import { ResponsiveText } from '@farmersdog/corgi-legacy';

export interface TitleProps {
  children: string;
  id: string | undefined;
}

export const Title = ({ children, id }: TitleProps) => (
  <ResponsiveText id={id} color="kale-3" variant="heading-3" as="h2">
    {children}
  </ResponsiveText>
);
